import ObjCommon from './ObjCommon';

class DlGroup extends ObjCommon {

  slug = '';
  fCond = {};

  constructor(id) {
    super(id);
  } 

  static groupTitleGet(gSlug) {
    let res = '';
    switch (gSlug) {
      case 'petar-lubarda':
        res = 'Petar Lubarda';        
        break;
      case 'sava-sumanovic':
        res = 'Sava Šumanović';        
        break;      
      case 'nadezda-petrovic':
        res = '';        
        break;      
      case 'muzej-savremene-umetnosti':
        res = 'Muzej savremene umetnosti';        
        break;      
      case 'avangarda':
        res = 'Avangarda';        
        break;      
      default:
        break;
    }

    return res;

  }



}

export default DlGroup;
